import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { ContentService } from 'src/app/views/content/content.service';
import { FileUploaderComponent } from '../../components/file-uploader/file-uploader.component';
import { MaterialModule } from '../../material.module';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-params-modal',
  templateUrl: './params-modal.component.html',
  styleUrls: ['./params-modal.component.scss'],
  standalone: true,
  imports: [MaterialModule, FileUploaderComponent, TranslateModule, FormsModule],
})
export class ParamsModalComponent implements OnInit {
  parents = [];
  children = [];
  settingsForm;
  state = 'start';
  addChoice;
  searchInput = '';
  chosenItem;
  lastTypedDate;
  timeOut = 0;
  searchMode = true;
  editMode;

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<ParamsModalComponent>,
    private toast: ToastService,
    private contentService: ContentService,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.settingsForm = this.fb.group({
      test: ['', [Validators.required]],
      test2: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.getParams();
  }
  deleteAttachment(attachment) {
    this.contentService.deleteAttachment(attachment).subscribe(
      (res) => {
        this.getParams();
        // history.go(0)
      },
      (err) => {
        if (!this.errorHandler.handle401Error(err)) {
          this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Close', {
            duration: 2000,
          });
        }
      }
    );
  }
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.id == 'cdk-drop-list-search') {
      if (event.previousContainer !== event.container) {
        const params = {
          item: event.previousContainer.data[event.previousIndex],
          type: event.container.id,
          contentID: this.data.contentID,
        };

        this.contentService.setContentParams(params).subscribe(
          (res) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.ParamsSetSuccess'), 'Ok', { duration: 2000 });
            this.getParams();
          },
          (err) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.ParamsSetFail'), 'Ok', { duration: 2000 });
          }
        );
      }
    } else {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else if ((event.previousContainer.id == 'Parent' && event.container.id == 'Child') || (event.previousContainer.id == 'Child' && event.container.id == 'Parent')) {
        this.contentService
          .setContentLinkType({
            lectureID: (event.previousContainer.data[event.previousIndex] as any).item.lecture._id,
            type: event.container.id,
          })
          .subscribe(
            (res) => {
              this.toast.snackbar.open(this.translate.instant('Snackbar.SavedMessage'), 'OK', { duration: 2000 });
            },
            (err) => {
              transferArrayItem(
                event.container.data, // go back
                event.previousContainer.data,
                event.currentIndex,
                event.previousIndex
              );
              if (!this.errorHandler.handle401Error(err)) {
                this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Close', {
                  duration: 2000,
                });
              }
            }
          );
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
    }
  }

  editItem(item) {
    this.chosenItem = item;

    this.editMode = true;
    this.searchMode = false;
  }

  switchToSearchMode() {
    this.editMode = false;
    this.searchMode = true;
  }
  refreshChosenItem() {
    if (this.chosenItem) {
      const all = this.parents.concat(this.children);
      for (const element of all) {
        if (element.item.lecture._id == this.chosenItem.item.lecture._id) {
          this.chosenItem.item = element;
        }
      }
    }
  }
  getParams() {
    this.contentService.getContentParams(this.data.contentID).subscribe(
      (res) => {
        this.parents = [];
        this.children = [];
        for (const obj of res) {
          if (obj.type == 'Parent') {
            this.parents.push(obj);
          } else {
            this.children.push(obj);
          }
        }
        this.refreshChosenItem();
      },
      (err) => {
        if (err.status == 404) {
          this.dialogRef.close();
          this.toast.snackbar.open(this.translate.instant('Snackbar.ContentNotFound'), 'Ok', { duration: 2000 });
        } else if (!this.errorHandler.handle401Error(err)) {
          this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Close', {
            duration: 2000,
          });
        }
      }
    );
  }

  setParams() {
    const params = this.settingsForm.value;
    params.contentID = this.data.contentID;
    this.contentService.setContentParams(params).subscribe(
      (res) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.ParamsSetSuccess'), 'Ok', { duration: 2000 });
        this.searchInput = '';
      },
      (err) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.ParamsSetFail'), 'Ok', { duration: 2000 });
      }
    );
  }

  highlight(element, word) {
    return element.replace(new RegExp(word, 'gi'), `<font color="red">${word}</font>`);
  }
  onAttachmentUploaded(event) {
    this.getParams();
  }

  performSearch(event) {
    if (this.searchInput.length > 0) {
      if (this.lastTypedDate) {
        if (moment().diff(this.lastTypedDate, 'seconds') > this.timeOut) {
          this.lastTypedDate = moment();
          this.search();
          this.chosenItem = undefined;
        } else {
          setTimeout(() => {
            if (this.searchRes.length > 0 && this.searchInput.length > 0 && !this.chosenItem) {
              this.search();
            }
          }, 1000);
        }
      } else {
        this.lastTypedDate = moment();
        this.search();
      }
    } else {
      this.searchRes = [];
    }
  }
  getParam(item) {
    const copy = JSON.parse(JSON.stringify(item));
    delete copy.attachments;
    return copy;
  }
  searchRes = [];
  search() {
    if (this.searchInput.length > 0) {
      this.contentService.searchLecture(this.searchInput).subscribe((res) => {
        this.searchRes = res;
      });
    }
  }

  open(item) {
    location.href = `knowledge/displayer/${item._id}/${item.section_id}/${item.lecture._id}`;
  }

  choose(item) {
    this.chosenItem = item;
  }
  delete(item) {
    this.contentService.deleteContentParam(item.lecture._id).subscribe(
      (res) => {
        this.getParams();
        this.switchToSearchMode();
      },
      (err) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.ParamsDeletionFail'), 'Ok', { duration: 2000 });
      }
    );
  }
}
